import { toastr } from 'react-redux-toastr'
let toastrOptions = { showCloseButton: false }

export default function showToastr (type, title, message) {
  toastrOptions = {...toastrOptions, status: type}
  switch (type) {
    case 'error':
      return toastr.error(title, message, toastrOptions)
    case 'info':
      return toastr.info(title, message, toastrOptions)
    case 'success':
      return toastr.success(title, message, toastrOptions)
    case 'warning':
      return toastr.warning(title, message, toastrOptions)
    default:
      return toastr.light(title, message, toastrOptions)
  }
}



// WEBPACK FOOTER //
// ./src/utils/showToastr.js